import { PropsWithChildren, useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, StripeElementsOptions } from "@stripe/stripe-js";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

type StripeProviderProps = PropsWithChildren<{
  clientSecret: string;
}>;

export function StripeProvider({
  clientSecret,
  children,
}: StripeProviderProps) {
  const options: StripeElementsOptions = useMemo(
    () => ({
      clientSecret,
      appearance: {
        theme: "stripe",
        labels: "floating",
      },
      locale: "it",
    }),
    [clientSecret],
  );

  return (
    <div className="min-h-screen w-full">
      <Elements stripe={stripePromise} options={options}>
        {children}
      </Elements>
    </div>
  );
}
